import { render, staticRenderFns } from "./EditRules.vue?vue&type=template&id=e459005c&scoped=true&"
import script from "./EditRules.vue?vue&type=script&lang=js&"
export * from "./EditRules.vue?vue&type=script&lang=js&"
import style0 from "./EditRules.vue?vue&type=style&index=0&id=e459005c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e459005c",
  null
  
)

export default component.exports